import { z } from 'zod';

export const HeroSection = z.object({
  kind: z.literal('hero'),
  eyebrow: z.string().optional(),
  headline: z.string(),
  sub: z.string(),
  ctas: z.array(
    z.object({
      label: z.string(),
      href: z.string(),
      variant: z.enum(['primary', 'ghost']).default('primary'),
    }),
  ),
  meta: z
    .array(
      z.object({
        key: z.string(),
        value: z.string(),
        detail: z.string().optional(),
      }),
    )
    .optional(),
});

export const SectionIntro = z.object({
  kind: z.literal('section-intro'),
  eyebrow: z.string(),
  heading: z.string(),
  body: z.string(),
});

export const ThreeColumn = z.object({
  kind: z.literal('three-column'),
  columns: z
    .array(
      z.object({
        num: z.string(),
        heading: z.string(),
        body: z.string(),
      }),
    )
    .length(3),
});

export const PullQuote = z.object({
  kind: z.literal('pull-quote'),
  quote: z.string(),
  cite: z.string(),
});

export const CtaStrip = z.object({
  kind: z.literal('cta-strip'),
  heading: z.string(),
  ctas: z.array(
    z.object({
      label: z.string(),
      href: z.string(),
      variant: z.enum(['primary', 'default']).default('default'),
    }),
  ),
});

export const CodeSample = z.object({
  kind: z.literal('code-sample'),
  language: z.string(),
  code: z.string(),
  heading: z.string(),
  body: z.string(),
});

export const SectionSchema = z.discriminatedUnion('kind', [
  HeroSection,
  SectionIntro,
  ThreeColumn,
  PullQuote,
  CtaStrip,
  CodeSample,
]);

export const PageSchema = z.object({
  slug: z.string(),
  seo: z.object({
    title: z.string(),
    description: z.string(),
  }),
  sections: z.array(SectionSchema),
});

export type Page = z.infer<typeof PageSchema>;
export type Section = z.infer<typeof SectionSchema>;
